import * as dateInput from '../../date-input';

export const initInScope = dateInput.createInitInScope({}, {
    base: '.js-ejb-date-input',
    input: '.js-ejb-date-input__input',
    output: '.js-ejb-date-input__output',
    openDatepicker: '.js-ejb-date-input__open-datepicker',
});
